export const VOUCHER_TYPE = {
  PERCENT: 'PERCENT',
  PRICE: 'PRICE',
  CHARACTER: 'CHARACTER', // RATIO_CHARACTER
  FIXED_CHARACTER: 'FIXED_CHARACTER',
  TIME: 'TIME',
  PERCENT_TIME: 'PERCENT_TIME',
};

export const TIME_TYPE = {
  MONTH: 'MONTH',
};

export const VOUCHER_COMPARISION_TYPE = {
  MONEY_DECREASE: 'MONEY_DECREASE',
  CHARACTER_EXTENSION: 'CHARACTER_EXTENSION',
  TIME_EXTENSION: 'TIME_EXTENSION',
};

export const VOUCHER_CURRENCY_UNIT = {
  VND: 'VND',
  USD: 'USD',
};

export const VOUCHER_REGION = {
  ALL: 'ALL',
  VN: 'VN',
  NON_VN: 'NON_VN',
};

export const DEFAULT_TIME_TO_RESET_COUNTDOWN = 1; // 1 hour
